import * as React from "react";
const SvgHurricane = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.9987 14.1667C6.3168 14.1667 3.33203 11.555 3.33203 8.33333C3.33203 5.11167 6.3168 2.5 9.9987 2.5M9.16536 17.5C12.8473 17.5 15.832 14.8883 15.832 11.6667C15.832 8.44501 12.8473 5.83333 9.16536 5.83333M9.95703 9.95833H9.96453M10.332 9.95833C10.332 10.1654 10.1641 10.3333 9.95703 10.3333C9.74992 10.3333 9.58203 10.1654 9.58203 9.95833C9.58203 9.75123 9.74992 9.58333 9.95703 9.58333C10.1641 9.58333 10.332 9.75123 10.332 9.95833Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgHurricane;
